export default function getSupportedLang() {
    let userDefaultLang = window.navigator.languages && window.navigator.languages[0];
    if (userDefaultLang){
        userDefaultLang = userDefaultLang.replace('-', '_').split('_')[0].toLowerCase()
    }

    const supportLang = ['en', 'ja', 'ko', 'zh', 'pt', 'es'];
    const userLanguage = supportLang.find((lang) => lang === userDefaultLang) || 'en';
    return userLanguage;
}